import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';

import { MaterialModule } from '@material/material.module';
import { SortCandidatesComponent } from '@shared/sort-candidates/sort-candidates.component';

@NgModule({
  imports: [CommonModule, MaterialModule, MatMenuModule],
  declarations: [SortCandidatesComponent],
  exports: [SortCandidatesComponent],
})
export class SortCandidatesModule {}
